<script setup lang="ts">
const searchTerm = defineModel<string>();

const props = defineProps<{
  autoFocus?: boolean;
  forceFullPlaceholder?: boolean;
}>();

const emit = defineEmits<{
  (e: 'beginSearch'): void;
}>();

const inputRef = ref<HTMLInputElement | null>(null);

const FULL_PLACEHOLDER_MIN_WIDTH = 130;

const isNarrow = ref(true);

const placeholder = computed(() =>
  !props.forceFullPlaceholder && isNarrow.value ? 'Поиск' : 'Поисковая фраза',
);

let resizeObserver: ResizeObserver | null = null;

function handleKeyDown(event: KeyboardEvent) {
  if (
    (event.key === 'Enter' || event.keyCode === 13) &&
    searchTerm.value?.trim()
  ) {
    emit('beginSearch');
  }
}

function focusInput() {
  inputRef.value?.focus();
}

defineExpose({
  focusInput,
});

onMounted(() => {
  if (props.autoFocus) {
    focusInput();
  }

  if (!inputRef.value || typeof ResizeObserver === 'undefined') return;

  resizeObserver = new ResizeObserver((entries) => {
    const width = entries[0]?.contentRect.width;

    if (width === undefined) return;

    isNarrow.value = width < FULL_PLACEHOLDER_MIN_WIDTH;
  });

  resizeObserver.observe(inputRef.value);
});

onBeforeUnmount(() => {
  resizeObserver?.disconnect();
  resizeObserver = null;
});
</script>

<template>
  <input
    ref="inputRef"
    v-model="searchTerm"
    type="text"
    name="search"
    :class="$style.searchField"
    :placeholder="placeholder"
    @keydown="handleKeyDown"
  />
</template>

<style module lang="scss">
.searchField {
  @include text_body2;
  color: var(--color-black-1);
  border: none;
  flex-grow: 1;
  padding-right: var(--space-2-5x);
  outline: none;
  width: 0;
}
</style>
